// src/useTheme.tsx
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { Helmet } from "react-helmet";
var ThemeProps = {
  className: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  showExpandedHeader: PropTypes.bool,
  logo: PropTypes.string.isRequired,
  appLogo: PropTypes.string.isRequired,
  font: PropTypes.string.isRequired,
  fontWeight: PropTypes.string.isRequired,
  mainColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  secondaryDarkColor: PropTypes.string.isRequired,
  secondaryColorLight: PropTypes.string.isRequired,
  secondaryColorLighter: PropTypes.string.isRequired,
  buttonColor: PropTypes.string.isRequired,
  accentColor: PropTypes.string.isRequired,
  secondaryAccentColor: PropTypes.string.isRequired,
  linkColor: PropTypes.string.isRequired,
  successColor: PropTypes.string.isRequired,
  buttonBorderRadius: PropTypes.string.isRequired,
  appBgColor: PropTypes.string.isRequired,
  appTitleFontColor: PropTypes.string.isRequired,
  appTitleBgColor: PropTypes.string.isRequired,
  appIconColor: PropTypes.string.isRequired,
  appIconSelectedColor: PropTypes.string.isRequired,
  appIconDisabledColor: PropTypes.string.isRequired,
  managementIconColor: PropTypes.string.isRequired
};
var ThemeShapeProps = PropTypes.shape(ThemeProps);
var VimThemes = /* @__PURE__ */ ((VimThemes2) => {
  VimThemes2["PREMERA"] = "premera";
  VimThemes2["SANITAS"] = "sanitas";
  VimThemes2["SANITAS_BLUE_THEME"] = "sanitasBlueTheme";
  VimThemes2["ALLSAVERS"] = "allsavers";
  VimThemes2["VIM"] = "vim";
  VimThemes2["VIM_CONNECT"] = "vimConnect";
  VimThemes2["WALGREENS"] = "walgreens";
  VimThemes2["FLORIDA_BLUE"] = "floridaBlue";
  VimThemes2["OPTUM"] = "optum";
  VimThemes2["MAX_HEALTH"] = "maxHealth";
  VimThemes2["ALEDADE"] = "aledade";
  VimThemes2["MOCK_CANVAS_APP"] = "mockCanvasApp";
  VimThemes2["AGILON"] = "agilon";
  VimThemes2["KAHUN"] = "kahun";
  VimThemes2["PRIVIA_INSIGHTS"] = "priviaInsights";
  VimThemes2["OFFICE_ALLY"] = "officeAlly";
  VimThemes2["ELATION"] = "elation";
  VimThemes2["TELADOC"] = "teladoc";
  VimThemes2["DR_CHRONO"] = "drChrono";
  VimThemes2["E_MEDICAL_PRACTICE"] = "eMedicalPractice";
  return VimThemes2;
})(VimThemes || {});
var themes = {
  premera: {
    className: "premera",
    fullName: "premera",
    logo: "//static.getvim.com/img/logos/premeraLogo2.png",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "loraregular , Helvetica, Arial, sans-serif",
    fontWeight: "normal",
    mainColor: "#313234",
    secondaryColor: "#117bab",
    secondaryDarkColor: "#117bab",
    secondaryColorLight: "#e1eaf1",
    secondaryColorLighter: "#f2f2f9",
    buttonColor: "#117bab",
    accentColor: "#e04e39",
    secondaryAccentColor: "#f63277",
    linkColor: "#117bab",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  sanitas: {
    className: "sanitas",
    fullName: "sanitas medical center",
    logo: "//static.getvim.com/img/logos/sanitasLogo.png",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#002E58",
    secondaryColor: "#7ba0c6",
    secondaryDarkColor: "#0071B8",
    secondaryColorLight: "#86a9cc",
    secondaryColorLighter: "#dae5f0",
    buttonColor: "#00B56C",
    accentColor: "#F63277",
    secondaryAccentColor: "#f63277",
    linkColor: "#1477D7",
    successColor: "#00B56C",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  sanitasBlueTheme: {
    className: "sanitas",
    fullName: "sanitas medical center",
    logo: "//static.getvim.com/img/logos/sanitasLogo.png",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "proximaNova, Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#045393",
    secondaryColor: "#48C85A",
    secondaryDarkColor: "#32333C",
    secondaryColorLight: "#e1eaf1",
    secondaryColorLighter: "#f2f2f9",
    buttonColor: "#045393",
    accentColor: "#FA7071",
    secondaryAccentColor: "#f63277",
    linkColor: "#045393",
    successColor: "#48C85A",
    buttonBorderRadius: "4px",
    appBgColor: "#f2f2f2",
    appTitleFontColor: "#011428",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  allsavers: {
    className: "uhc",
    fullName: "united healthcare",
    logo: "//static.getvim.com/img/logos/uhcLogo.png",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#0071b8",
    secondaryDarkColor: "#0071b8",
    secondaryColorLight: "#e1eaf1",
    secondaryColorLighter: "#f2f2f9",
    buttonColor: "#278600",
    accentColor: "#e74476",
    secondaryAccentColor: "#f63277",
    linkColor: "#0071b8",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  vim: {
    className: "vim",
    fullName: "vim",
    logo: "//static.getvim.com/img/logos/vimLogoMdTM.png",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#09ace4",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#bfdce6",
    secondaryColorLighter: "#d9eaf1",
    buttonColor: "#083a6b",
    accentColor: "#e74476",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  vimConnect: {
    className: "vim-connect",
    fullName: "Vim Connect",
    logo: "//static.getvim.com/img/logos/VimIconMd.svg",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#001C36",
    secondaryColor: "#0076a4",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#c2dee7",
    secondaryColorLighter: "#dbeaf3",
    buttonColor: "#001C36",
    accentColor: "#e02062",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  walgreens: {
    className: "walgreens",
    fullName: "walgreens",
    logo: "//static.getvim.com/img/logos/walgreensLogo.png",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "Source Sans Pro",
    fontWeight: "bold",
    mainColor: "#323264",
    secondaryColor: "#e62600",
    secondaryDarkColor: "#e1f4ff",
    secondaryColorLight: "#F5F5F0",
    secondaryColorLighter: "#F5F5EE",
    buttonColor: "#323264",
    accentColor: "#FEC4CE",
    secondaryAccentColor: "#f63277",
    linkColor: "#323264",
    successColor: "#278600",
    buttonBorderRadius: "50px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  floridaBlue: {
    className: "fb",
    fullName: "florida blue",
    logo: "//static.getvim.com/img/logos/floridaBlueLogo.png",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#0f5499",
    secondaryColor: "#0091cb",
    secondaryDarkColor: "#0071B8",
    secondaryColorLight: "#e1eaf1",
    secondaryColorLighter: "#f2f2f9",
    buttonColor: "#43b02a",
    accentColor: "#E74476",
    secondaryAccentColor: "#f63277",
    linkColor: "#1477D7",
    successColor: "#43b02a",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  optum: {
    className: "optum",
    fullName: "Optum",
    logo: "//static.getvim.com/img/logos/Optum-logo-2021.svg",
    appLogo: "//static.getvim.com/img/logos/optum-app-logo.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#000000",
    secondaryDarkColor: "#454445",
    secondaryColorLight: "#373737",
    secondaryColorLighter: "#454445",
    buttonColor: "#000000",
    accentColor: "#e02062",
    secondaryAccentColor: "#f63277",
    linkColor: "#000000",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#ffffff",
    appTitleBgColor: "#ffbb00",
    appIconColor: "#ffffff",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#ffffff50",
    managementIconColor: "#737273"
  },
  maxHealth: {
    className: "max-health",
    fullName: "Max Health",
    showExpandedHeader: true,
    logo: "//static.getvim.com/img/logos/MaxWell_160x30.png",
    appLogo: "//static.getvim.com/img/logos/MaxWell_30x30.png",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#0076a4",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#c2dee7",
    secondaryColorLighter: "#dbeaf3",
    buttonColor: "#083a6b",
    accentColor: "#e02062",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  aledade: {
    className: "aledade",
    fullName: "Aledade",
    logo: "//static.getvim.com/img/logos/aledade_2.svg",
    appLogo: "//static.getvim.com/img/logos/aledade_2.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#0076a4",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#c2dee7",
    secondaryColorLighter: "#dbeaf3",
    buttonColor: "#083a6b",
    accentColor: "#e02062",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  mockCanvasApp: {
    className: "mock-canvas-app",
    fullName: "Mock Canvas App",
    logo: "https://s3.us-west-2.amazonaws.com/static.getvim.com/img/logos/MockCanvasIcon.svg",
    appLogo: "https://s3.us-west-2.amazonaws.com/static.getvim.com/img/logos/MockCanvasIcon.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#0076a4",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#c2dee7",
    secondaryColorLighter: "#dbeaf3",
    buttonColor: "#083a6b",
    accentColor: "#e02062",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  agilon: {
    className: "agilon",
    fullName: "Agilon",
    showExpandedHeader: true,
    logo: "//static.getvim.com/img/logos/Agilon_Logo.svg",
    appLogo: "//static.getvim.com/img/logos/Agilon_Logo_Icon_Only.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#113253",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#77a1c8",
    secondaryColorLighter: "#ecf2f7",
    buttonColor: "#2973a8",
    accentColor: "#e31b0c",
    secondaryAccentColor: "#f44336",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "2px",
    appBgColor: "#fafafa",
    appTitleFontColor: "#011428",
    appTitleBgColor: "#f5f5f5",
    appIconColor: "#707070",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#bdbdbd",
    managementIconColor: "#707070"
  },
  kahun: {
    className: "kahun",
    fullName: "Kahun",
    logo: "//static.getvim.com/img/logos/VimIconMd.svg",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#dbeaf3",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#c2dee7",
    secondaryColorLighter: "#dbeaf3",
    buttonColor: "#083a6b",
    accentColor: "#e02062",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#5A52C3",
    appIconSelectedColor: "#5A52C3",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#5A52C3"
  },
  priviaInsights: {
    className: "privia-insights",
    fullName: "privia-insights",
    logo: "//static.getvim.com/img/logos/PriviaIcon.svg",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#0076a4",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#c2dee7",
    secondaryColorLighter: "#dbeaf3",
    buttonColor: "#083a6b",
    accentColor: "#e02062",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#5A52C3",
    appIconSelectedColor: "#5A52C3",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#5A52C3"
  },
  officeAlly: {
    className: "office-ally",
    fullName: "Office Ally",
    logo: "//static.getvim.com/img/logos/VimIconMd.svg",
    appLogo: "//static.getvim.com/img/logos/VimIconMd.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#050954",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#b8b9cd",
    secondaryColorLighter: "#EEF0F6",
    buttonColor: "#050954",
    accentColor: "#e02062",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#f2f2f2",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  elation: {
    className: "elation",
    fullName: "Elation",
    logo: "//static.getvim.com/img/logos/ElationIcon.svg",
    appLogo: "//static.getvim.com/img/logos/ElationIcon.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#1C94BC",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#C2DEE7",
    secondaryColorLighter: "#DBEAF3",
    buttonColor: "#1C94BC",
    accentColor: "#e02062",
    secondaryAccentColor: "#e02062",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#000000",
    appBgColor: "#F0F0F0",
    appTitleBgColor: "#e6e6e6",
    appIconColor: "#001C36",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#b3bac0",
    managementIconColor: "#051427"
  },
  teladoc: {
    className: "teladoc",
    fullName: "Teladoc",
    logo: "//static.getvim.com/img/logos/teladoc-icon-new.svg",
    appLogo: "//static.getvim.com/img/logos/teladoc-icon-new.svg",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryColor: "#1F6E8B",
    secondaryDarkColor: "#09ace4",
    secondaryColorLight: "#F5F5F5",
    secondaryColorLighter: "#FFFFFF",
    buttonColor: "#242424",
    accentColor: "#F63277",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appBgColor: "#F0F0F0",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#ffffff",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427"
  },
  drChrono: {
    className: "dr-chrono",
    fullName: "Dr Chrono",
    logo: "//static.getvim.com/img/logos/dr_chrono.png",
    appLogo: "//static.getvim.com/img/logos/dr_chrono.png",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#083a6b",
    secondaryDarkColor: "#09ace4",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appIconColor: "#051427",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427",
    appTitleFontColor: "#fafafa",
    appTitleBgColor: "#333333",
    appBgColor: "#f5f5f5",
    buttonColor: "#41a429",
    secondaryColor: "#41a429",
    secondaryColorLight: "#80cb6c",
    secondaryColorLighter: "#c4e1bc",
    accentColor: "#de0000",
    appIconSelectedColor: "#FFFFFF"
  },
  eMedicalPractice: {
    className: "theme-name",
    fullName: "Theme Name",
    logo: "//static.getvim.com/img/logos/e_medical_practice.png",
    appLogo: "//static.getvim.com/img/logos/e_medical_practice.png",
    font: "proximaNova , Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    mainColor: "#001C36",
    secondaryDarkColor: "#09ace4",
    secondaryAccentColor: "#f63277",
    linkColor: "#09ace4",
    successColor: "#278600",
    buttonBorderRadius: "4px",
    appTitleFontColor: "#011428",
    appTitleBgColor: "#e5e5e5",
    appIconColor: "#051427",
    appIconSelectedColor: "#FFFFFF",
    appIconDisabledColor: "#05142750",
    managementIconColor: "#051427",
    appBgColor: "#f0f0f0",
    buttonColor: "#001C36",
    secondaryColor: "#015d7d",
    secondaryColorLight: "#c2dee7",
    secondaryColorLighter: "#dbeaf3",
    accentColor: "#e02062"
  }
};
var currentThemeContext = React.createContext(themes.vim);
var ThemeContext = (theme = themes.vim) => {
  currentThemeContext = React.createContext(theme);
  return currentThemeContext;
};
var useTheme = () => useContext(currentThemeContext);
var ThemeVariablesWrapper = ({
  theme,
  children,
  className
}) => {
  const themeCssVariables = Object.keys(theme).reduce((acc, themePascalCase) => {
    const themeKebabCase = themePascalCase.replace(/([A-Z])/g, "-$1").toLowerCase();
    const themeKeyAsVariable = `--${themeKebabCase}`;
    if (themePascalCase === "logo" || themePascalCase === "appLogo" || themePascalCase === "titleLogo") {
      acc += `${themeKeyAsVariable}: url("${theme[themePascalCase]}");`;
    } else {
      acc += `${themeKeyAsVariable}: ${theme[themePascalCase]};`;
    }
    return acc;
  }, ``);
  const variablesAsStyle = `
  :root {
    ${themeCssVariables}
  }
  `;
  return /* @__PURE__ */ React.createElement("div", {
    id: "theme-css-variables-wrapper",
    className
  }, /* @__PURE__ */ React.createElement(Helmet, null, /* @__PURE__ */ React.createElement("style", null, variablesAsStyle)), children);
};
export {
  ThemeContext,
  ThemeProps,
  ThemeShapeProps,
  ThemeVariablesWrapper,
  VimThemes,
  themes,
  useTheme
};
//# sourceMappingURL=index.js.map
